import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import { Icon } from "components/mui";
import React from "react";
import { getCloudFrontUrl, EMPTY_STATE_IMAGE, EMPTY_STATE_IMAGE_2x } from "utils/staticFiles";
import { jsx as _jsx } from "react/jsx-runtime";
export var ImageWithFallback = function ImageWithFallback(_ref) {
  var _ref$onImageClick = _ref.onImageClick,
    onImageClick = _ref$onImageClick === void 0 ? function () {} : _ref$onImageClick,
    _ref$onImageError = _ref.onImageError,
    onImageError = _ref$onImageError === void 0 ? function () {} : _ref$onImageError,
    className = _ref.className,
    imageSrc = _ref.imageSrc,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? "default" : _ref$iconSize,
    extraProps = _ref.extraProps;
  var fallBackImage = size === "medium" ? getCloudFrontUrl(EMPTY_STATE_IMAGE) : getCloudFrontUrl(EMPTY_STATE_IMAGE_2x);

  // Default to empty state image if no image src is provided, or if the image src fails to load
  var srcProvided = !!imageSrc;
  if (!srcProvided) {
    imageSrc = fallBackImage;
  }
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    useIcon = _React$useState2[0],
    setUseIcon = _React$useState2[1];
  var onError = function onError(e) {
    e.currentTarget.onerror = null;
    if (size === "small") {
      setUseIcon(true);
    } else {
      setUseIcon(false);
      e.currentTarget.src = fallBackImage;
    }
  };
  return useIcon ? /*#__PURE__*/_jsx(Icon, {
    className: IconConstants.CITY,
    fontSize: iconSize
  }) : /*#__PURE__*/_jsx("img", _objectSpread({
    className: className,
    src: imageSrc,
    decoding: srcProvided ? undefined : "async",
    onError: srcProvided ? onError : onImageError,
    onClick: onImageClick
  }, extraProps));
};